import { Component, Input } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-message-modal',
  template: `
      <app-modal-container
        [title]="title"
        [extraCssLinkBtn]="extraCssLinkBtn"
        [extraCssPrimaryBtn]="extraCssPrimaryBtn"
        [labelConfirm]="labelConfirm"
        [labelCancel]="labelCancel"
        [dismissible]="dismissible">
        <p [innerHtml]="modalText"></p>
      </app-modal-container>
  `
})
export class MessageModalComponent {

  @Input()
  modalText: string;

  @Input()
  title: string;

  @Input()
  labelConfirm: string;

  @Input()
  labelCancel: string;

  @Input()
  extraCssLinkBtn: string;

  @Input()
  extraCssPrimaryBtn: string;

  @Input()
  dismissible: boolean;

}
